import { createBaseApi } from '../baseApi';
import { getThumbnailUrl } from '../../../utils/imageUtils';

const vtoApi = createBaseApi('vtoApi');

export const enhancedVtoApi = vtoApi.injectEndpoints({
    endpoints: (builder) => ({
        tryOnAsync: builder.mutation({
            query: (data) => ({
                url: '/virtual-try-on/try-on-async',
                method: 'POST',
                body: data
            })
        }),
        getVtoStatus: builder.query({
            query: (jobId) => `/virtual-try-on/status/${jobId}`
        }),
        saveVtoResult: builder.mutation({
            query: (formData) => ({
                url: '/virtual-try-on-results/upload',
                method: 'POST',
                body: formData,
                formData: true
            }),
            invalidatesTags: ['InCloset']
        }),
        getMyPersonImages: builder.query({
            query: () => '/person-images?_sort=created_at:desc',
            // Backend returns { personImages: [...], pagination: {...} }
            transformResponse: (response) => response.personImages || response || []
        }),
        getVtoResultsByGarment: builder.query({
            query: (closetClothesId) => `/virtual-try-on-results/by-garment/${closetClothesId}`,
            transformResponse: (response) => {
                const results = response.results || [];
                return results.map(item => {
                    let resultImageUrl = item.imageUrl || item.resultImage;
                    if (Array.isArray(resultImageUrl)) resultImageUrl = resultImageUrl[resultImageUrl.length - 1];
                    if (resultImageUrl && typeof resultImageUrl === 'object') resultImageUrl = resultImageUrl.url;
                    
                    let allImagesArray = item.allImages || item.backendResult?.allImages;
                    if (!allImagesArray) {
                        if (Array.isArray(item.resultImage)) {
                            allImagesArray = item.resultImage.map(img => typeof img === 'object' ? img.url : img).filter(Boolean);
                        } else if (resultImageUrl) {
                            allImagesArray = [resultImageUrl];
                        } else {
                            allImagesArray = [];
                        }
                    }
                    
                    return {
                        ...item,
                        imageUrl: getThumbnailUrl(resultImageUrl, 300),
                        allImages: allImagesArray
                    };
                });
            },

            providesTags: (result, error, arg) => [{ type: 'VtoResult', id: arg }]
        })
    }),
    overrideExisting: false
});

export const {
    useTryOnAsyncMutation,
    useGetVtoStatusQuery,
    useSaveVtoResultMutation,
    useGetMyPersonImagesQuery,
    useGetVtoResultsByGarmentQuery
} = enhancedVtoApi;

export default enhancedVtoApi;
